export default {"src":"/_next/static/media/circleGavel_24.46260790.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};